export default "__VITE_ASSET__BuPhnBL4__"